exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".mobile-modal[data-v-87f2a3aa]{display:flex;position:absolute;z-index:1500;top:0;left:0;width:100%;height:100vh;margin:0;background-color:rgba(50,50,50,.99)}.mainbox[data-v-87f2a3aa]{background-color:#eee;width:20em;height:250px;text-align:center;width:90vw;margin:5vw;border-radius:4px;filter:drop-shadow(3px 3px 3px #000000);-webkit-filter:drop-shadow(3px 3px 3px #000)}.mainbox>p[data-v-87f2a3aa]{width:90%;margin:auto;margin-top:20px;font-family:Nunito,sans-serif;font-size:1.25em}.mainbox>p[data-v-87f2a3aa]:nth-of-type(2){margin-top:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-87f2a3aa","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/containers/section1/Section1.vue
// module id = 89
// module chunks = 0